import React from 'react';
import PropTypes from 'prop-types';
import AuthLink from '../auth-route/AuthLink';
import { connect } from 'react-redux';
import { USER_FLOW_JUMP_TO, STORE_DHA_CHALLAN_DATA } from '../../redux/action-contants';
import withRouterV6 from '../common/withRouterV6';
import { logoutRequest } from '@Redux/actions/authentication';
import {
  setZenDeskActiveChat,
  toggleIsRevampApiCalled
} from '../../redux/actions/help-center-action/help-center-actions';
import {
  changeScreen,
  destroyUserFlowAction
} from '../../redux/actions/user-flow/user-flow-action';
import { toggleSidebar } from '../../redux/actions/ui-trigger/ui-trigger-action';
import { resetTransactionDetails } from '../../redux/actions/common/common-action';
import { Link } from 'react-router-dom';
import {
  AUTHORIZATIONS,
  BASE_URL,
  DASHBOARD_URL,
  HISTORY_URL,
  INSTAPOINTS_URL,
  PAYEE_LIST_URL,
  REFERRAL_URL,
  SUBSCRIPTION_URL,
  TRANSFER_MONEY_URL,
  USER_PROFILE_URL,
  INDIVIDUAL,
  MULTIPLE_TRANSACTION_URL,
  MANAGE_PAYMENT_OPTION_URL,
  APPROVED,
  CORPORATE,
  AMAZE_URL,
  HK,
  US,
  SG,
  UK,
  AU,
  EU_REGION,
  POST_LOGOUT_URL,
  CORPORATE_CUSTOMER_SUPPORT_EMAIL,
  NIUM_FOREX_URL,
  HEADER_FOOTER_IGNORED_URLS,
  APP_ONLY_CORRIDOOR_WELCOME_URL,
  NIUM_FOREX_HELP_EMAIL_MESSAGE,
  ADD_PAYEE_URL,
  POST_LOGOUT
} from '../../utils/constants';
import {
  AMAZE_ICON,
  FAQ_ICON,
  HISTORY_ICON,
  INSTAPOINTS_ICON,
  INVITE_ICON,
  LOGOUT_ICON,
  MANAGE_PAYMENT_OPT_ICON,
  RECIPIENT_ICON,
  RECIPIENTS,
  SEND_MONEY_ICON,
  SUBSCRIPTION_ICON,
  REFERRAL_SMALL_ICON
} from '@Images';
import './sidebar.scss';
import get from 'lodash/get';
import {
  isAmazeFlow,
  isKYCSplitFlow,
  isMobileDevice,
  shouldShowPaymentOptionTab
} from '../../utils/library';
import HelpCenterDecide from '../HelpCenterNavigation/HelpcenterNavSwitch';
import { FLOW_TYPE_SEND_MONEY, SEND_MONEY } from '../../utils/constants/eventsConstants';
import { NF_ALLOWED_ROUTES, NF_SCREENS } from '../../screens/nium-forex/root/screenConstants';
import { getPageName, logEvent, logEventV2 } from '../../utils/events/logUserEvents';
import {
  EventButtonType,
  EventNamesV2,
  FLOW_TYPE,
  LOG_TYPE
} from '../../utils/events/eventsConstants';
import { toggleNewCouponCode } from '@Redux/actions/transaction';
import { storeSelectedBeneList } from '../../redux/actions/transaction/transaction-action';
import { clearDashboardCalculatorData } from '@Redux/actions/dashboard';

function isAuthorized(user_status, url, props) {
  const countryCode = get(props, 'user_status.country_code', '');
  const accountType = get(props, 'user_status.account_type', '');
  const splitKYC = isKYCSplitFlow(countryCode, user_status, true, accountType);
  const isNiumForexUser = get(props, 'isNiumForexUser', false);
  const niumForexCurrentScreen = get(props, 'niumForexCurrentScreen', '');
  const pathname = get(props, 'location.pathname', '');
  const isPreDashboard =
    pathname === NIUM_FOREX_URL && niumForexCurrentScreen === NF_SCREENS.mobile_verification;
  if (isNiumForexUser) {
    if (isPreDashboard) return false;
    return NF_ALLOWED_ROUTES.includes(url);
  }
  const paths = AUTHORIZATIONS[splitKYC ? APPROVED : user_status];
  return paths && paths.find((text) => text === url);
}

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideLogOutButton: false // for react-native web view
    };
  }

  componentDidMount() {
    if (window?.ReactNativeWebView || window?.WebViewBridge) {
      this.setState({ hideLogOutButton: true });
    }
  }

  renderHelpForNiumForexUser = () => {
    const mailtoLink = `mailto:${NIUM_FOREX_HELP_EMAIL_MESSAGE.email}?subject=${encodeURIComponent(
      `${NIUM_FOREX_HELP_EMAIL_MESSAGE.subject}${this.props.email}`
    )}&body=${encodeURIComponent(NIUM_FOREX_HELP_EMAIL_MESSAGE.body)}`;

    const handleHelpClick = (e) => {
      e.preventDefault();
      if (window?.ReactNativeWebView) {
        window?.ReactNativeWebView.postMessage(mailtoLink);
      } else if (isMobileDevice()) {
        window.location.href = mailtoLink;
      } else {
        window.open(mailtoLink, '_blank');
      }
    };

    return (
      <div className="header-links">
        <div className="icon">
          <img alt="help" src={FAQ_ICON} />
        </div>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="#" onClick={handleHelpClick} rel="noopener noreferrer">
          Help
        </a>
      </div>
    );
  };

  onSendMoney = () => {
    logEvent(SEND_MONEY, FLOW_TYPE_SEND_MONEY);
    const { currentScreen, screens, timeline, navigate, location } = this.props;
    const current_path = location.pathname;

    if (current_path === TRANSFER_MONEY_URL && currentScreen === 'send-money') return;
    if (current_path === TRANSFER_MONEY_URL && currentScreen !== 'send-money') {
      //user standing on same route but different screen
      this.props.resetTransactionDetails();
      this.props.changeScreen(USER_FLOW_JUMP_TO, 'send_money', screens, timeline);
    } else {
      //user standing on different route than /transfer-money
      this.props.resetTransactionDetails();
      navigate(TRANSFER_MONEY_URL);
      this.props.toggleSidebar();
    }
  };

  disableZendesk = () => {
    const { zE: zenDesk } = window;
    if (zenDesk) {
      zenDesk('messenger', 'logoutUser');
      this.props.setZenDeskActiveChat(false);
    }
  };

  logout = async () => {
    const response = await this.props.logoutRequest();
    if (response && response.data && response.data.success) {
      this.disableZendesk();
      this.props.toggleIsRevampApiCalled(false);
      if (localStorage.getItem(POST_LOGOUT) !== null) return this.props.navigate(POST_LOGOUT_URL);
      window.location = window.location.origin;
    }
  };

  cleverTapEvent = (eventName) => {
    const ctData = {
      pageName: 'Settings'
    };
    logEvent(eventName, null, ctData, LOG_TYPE.CLEVER_TAP);
    this.props.destroyUserFlowAction();
    this.props.storeSelectedBeneList({});
    this.props.clearDhaChallanData();
    this.props.toggleSidebar();
  };
  onLinkClick = (targetUrl) => {
    const { destroyUserFlowAction, toggleSidebar } = this.props;
    toggleSidebar();
    destroyUserFlowAction();
    if (this.props.transactionDetails?.selectedBene?.is_dha_beneficiary) {
      this.props.storeSelectedBeneList({});
      this.props.clearDhaChallanData();
    }
    if (targetUrl === DASHBOARD_URL) {
      // Clear coupon Code data and Dashboard calculator data
      this.props.toggleNewCouponCode(false);
      this.props.clearDashboardCalculatorData();
    }
  };

  shownNavLinkAddPayee = () => {
    const { currentScreen } = this.props;
    if (
      window.location.pathname === ADD_PAYEE_URL ||
      (window.location.pathname === TRANSFER_MONEY_URL && currentScreen === 'add_beneficiary')
    )
      return false;

    return true;
  };

  render() {
    const {
        user_status,
        user_status: { country_code },
        account_type,
        isNiumForexUser
      } = this.props,
      { pathname } = this.props.location;
    const { destroyUserFlowAction } = this.props;
    const status = user_status ? user_status.status : 'NONE';
    const countryCode = user_status ? user_status.country_code : null;
    const isTransferMoneyURL = pathname === TRANSFER_MONEY_URL;
    const showManagePayment = [HK, US, SG, UK, AU, ...EU_REGION];
    if (
      (/signin|signup|invite\/|password/gi.test(pathname) || pathname === BASE_URL) &&
      !HEADER_FOOTER_IGNORED_URLS.includes(pathname)
    )
      return null;
    const isIndividual = account_type === INDIVIDUAL;
    const paymentOptionTabVisible = shouldShowPaymentOptionTab(country_code);
    const niumForexCurrentScreen = get(this.props, 'niumForexCurrentScreen', '');
    const isPreDashboard =
      pathname === NIUM_FOREX_URL && niumForexCurrentScreen === NF_SCREENS.mobile_verification;
    const isAppOnlyCorridorRoute = window.location.href.includes(APP_ONLY_CORRIDOOR_WELCOME_URL);

    const logCTEvents = (ctaName, flowType) => {
      const eventProperty = {
        type: EventButtonType.LINK,
        pageName: getPageName(),
        ctaName,
        flowType
      };
      logEventV2(EventNamesV2.CTA_CLICKED, eventProperty);
    };

    return (
      <>
        <div className="sidebar">
          {!isPreDashboard && !isAppOnlyCorridorRoute && (
            <div>
              {!isTransferMoneyURL &&
                isAuthorized(status, TRANSFER_MONEY_URL, this.props) &&
                this.shownNavLinkAddPayee() && (
                  <div className="header-links">
                    <div className="icon">
                      <img alt="dashboard" src={SEND_MONEY_ICON} />
                    </div>
                    <AuthLink
                      caption={'Send money'}
                      target_path={
                        account_type === INDIVIDUAL ? TRANSFER_MONEY_URL : MULTIPLE_TRANSACTION_URL
                      }
                      id="link-send-money"
                      onClick={() => {
                        destroyUserFlowAction();
                        this.props.toggleNewCouponCode(false);
                        this.props.clearDashboardCalculatorData();
                        this.onSendMoney();
                      }}
                      key={'link-send-money'}
                    />
                  </div>
                )}
              {!isTransferMoneyURL &&
                isAuthorized(status, AMAZE_URL, this.props) &&
                isAmazeFlow(countryCode, account_type) &&
                this.shownNavLinkAddPayee() && (
                  <div className="header-links">
                    <div className="icon">
                      <img alt="dashboard" src={AMAZE_ICON} />
                    </div>
                    <AuthLink
                      caption={'amaze'}
                      target_path={AMAZE_URL}
                      id="link-amaze"
                      onClick={() => {
                        destroyUserFlowAction();
                        this.onSendMoney();
                      }}
                      key={'link-amaze'}
                    />
                  </div>
                )}
              {!isTransferMoneyURL &&
                isAuthorized(status, PAYEE_LIST_URL, this.props) &&
                this.shownNavLinkAddPayee() && (
                  <div className="header-links">
                    <div className="icon">
                      <img alt="dashboard" src={RECIPIENTS} />
                    </div>
                    <AuthLink
                      className="header-links"
                      caption={'Recipients'}
                      target_path={PAYEE_LIST_URL}
                      id="link-payee-list"
                      onClick={() => {
                        this.onLinkClick();
                      }}
                    />
                  </div>
                )}
              {!isTransferMoneyURL &&
                isAuthorized(status, HISTORY_URL, this.props) &&
                this.shownNavLinkAddPayee() && (
                  <div className="header-links">
                    <div className="icon">
                      <img alt="History icon" src={HISTORY_ICON} />
                    </div>
                    <AuthLink
                      className="header-links"
                      caption={'History'}
                      target_path={HISTORY_URL}
                      id="link-transaction-history"
                      onClick={this.onLinkClick}
                    />
                  </div>
                )}
              {!isTransferMoneyURL &&
                isIndividual &&
                isAuthorized(status, INSTAPOINTS_URL, this.props) &&
                this.shownNavLinkAddPayee() && (
                  <div className="header-links">
                    <div className="icon">
                      <img alt="Instapoint icon" src={INSTAPOINTS_ICON} />
                    </div>
                    <AuthLink
                      className="header-links"
                      caption={'InstaPoints'}
                      target_path={INSTAPOINTS_URL}
                      id="link-referral"
                      onClick={this.onLinkClick}
                    />
                  </div>
                )}
              {!isTransferMoneyURL &&
                isAuthorized(status, REFERRAL_URL, this.props) &&
                account_type !== CORPORATE &&
                this.shownNavLinkAddPayee() && (
                  <div className="header-links">
                    <div className="icon">
                      <img alt="Invite icon" src={INVITE_ICON} />
                    </div>
                    <AuthLink
                      className="header-links"
                      caption={'Refer & earn'}
                      target_path={REFERRAL_URL}
                      id="link-referral"
                      onClick={() => {
                        this.onLinkClick();
                        logCTEvents('Refer & earn', FLOW_TYPE.REFERRALS);
                      }}
                    />
                  </div>
                )}
              <div className="header-links">
                {((authorized) => [
                  <div key={'icon'} className="icon">
                    <img
                      alt="user-profile"
                      src={RECIPIENT_ICON}
                      className={!authorized ? ' disabled' : ''}
                    />
                  </div>,
                  <Link
                    key={'link'}
                    to={USER_PROFILE_URL}
                    id="link-user-profile"
                    className={'head' + (!authorized ? ' disabled' : '')}
                    onClick={(e) => {
                      !authorized && e.preventDefault();
                      this.onLinkClick();
                    }}
                  >
                    {'My info'}
                  </Link>
                ])(isAuthorized(status, USER_PROFILE_URL, this.props))}
              </div>
              <div className="header-links">
                <div className="icon">
                  <img alt="dashboard" src={SEND_MONEY_ICON} />
                </div>
                <Link
                  to={DASHBOARD_URL}
                  className="head"
                  onClick={() => {
                    logCTEvents('dashboard', FLOW_TYPE.DASHBOARD);
                    this.onLinkClick(DASHBOARD_URL);
                  }}
                >
                  Dashboard
                </Link>
              </div>
              {status === APPROVED &&
                showManagePayment.includes(countryCode) &&
                paymentOptionTabVisible &&
                account_type !== CORPORATE && (
                  <div className="header-links">
                    <div className="icon">
                      <img alt="Manage payment icon" src={MANAGE_PAYMENT_OPT_ICON} />
                    </div>
                    <Link
                      to={MANAGE_PAYMENT_OPTION_URL}
                      className="head"
                      onClick={this.onLinkClick}
                    >
                      Manage payment options
                    </Link>
                  </div>
                )}
              {!isNiumForexUser && (
                <div className="header-links">
                  <div className="icon">
                    <img alt="Subscription icon" src={SUBSCRIPTION_ICON} />
                  </div>
                  <Link to={SUBSCRIPTION_URL} className="head" onClick={this.onLinkClick}>
                    Subscription
                  </Link>
                </div>
              )}
              {!isNiumForexUser && status !== APPROVED && account_type !== CORPORATE && (
                <div className="header-links">
                  <div className="icon">
                    <img alt="Referral icon" src={REFERRAL_SMALL_ICON} />
                  </div>
                  <Link to={REFERRAL_URL} className="head" onClick={this.onLinkClick}>
                    Referrals
                  </Link>
                </div>
              )}
            </div>
          )}
          {isNiumForexUser ? (
            this.renderHelpForNiumForexUser()
          ) : !isAppOnlyCorridorRoute ? (
            isIndividual ? (
              <div className="header-links">
                <div className="icon" onClick={() => destroyUserFlowAction()}>
                  <img alt="help-center" src={FAQ_ICON} />
                </div>
                <HelpCenterDecide cleverTapEvent={this.cleverTapEvent} />
              </div>
            ) : (
              <div className="header-links">
                <div className="icon">
                  <img alt="help" src={FAQ_ICON} />
                </div>
                <a
                  href={`mailto:${CORPORATE_CUSTOMER_SUPPORT_EMAIL}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Help
                </a>
              </div>
            )
          ) : null}
          {!this.state.hideLogOutButton && (
            <div className="header-links">
              <div className="icon">
                <img alt="logout" src={LOGOUT_ICON} onClick={() => destroyUserFlowAction()} />
              </div>
              <a
                href="#!"
                className="head"
                onClick={(e) => {
                  e.preventDefault();
                  this.logout();
                }}
                id="btn-logut"
              >
                Logout
              </a>
            </div>
          )}
        </div>
      </>
    );
  }
}

Sidebar.propTypes = {
  userStatusReducer: PropTypes.object,
  navigate: PropTypes.func,
  logoutRequest: PropTypes.func,

  user_status: PropTypes.object,
  screens: PropTypes.array,
  currentScreen: PropTypes.string,
  timeline: PropTypes.array,
  changeScreen: PropTypes.func,
  location: PropTypes.any,
  resetTransactionDetails: PropTypes.func,
  toggleSidebar: PropTypes.func,
  account_type: PropTypes.string,
  destroyUserFlowAction: PropTypes.any,
  isNiumForexUser: PropTypes.bool,
  niumForexCurrentScreen: PropTypes.string,
  setZenDeskActiveChat: PropTypes.func,
  toggleIsRevampApiCalled: PropTypes.func,
  toggleNewCouponCode: PropTypes.func,
  clearDashboardCalculatorData: PropTypes.func,
  email: PropTypes.string,
  transactionDetails: PropTypes.object,
  storeSelectedBeneList: PropTypes.func,
  clearDhaChallanData: PropTypes.func
};

function mapStateToProps(reduxState) {
  const {
    rootReducer: {
      userStatusReducer,
      userStatusReducer: user_status,
      userFlowReducer: { screens, currentScreen, timeline },
      userSessionReducer: {
        user_session: { account_type, email }
      },
      transactionReducer: { transactionDetails },
      niumForexReducer: { isNiumForexUser, currentScreen: niumForexCurrentScreen }
    }
  } = reduxState;
  return {
    userStatusReducer,
    user_status,
    screens,
    currentScreen,
    timeline,
    account_type,
    isNiumForexUser,
    niumForexCurrentScreen,
    email,
    transactionDetails
  };
}

export default withRouterV6(
  connect(mapStateToProps, {
    logoutRequest,
    changeScreen,
    toggleSidebar,
    resetTransactionDetails,
    destroyUserFlowAction,
    setZenDeskActiveChat,
    toggleIsRevampApiCalled,
    toggleNewCouponCode,
    clearDashboardCalculatorData,
    storeSelectedBeneList,
    clearDhaChallanData: () => ({ type: STORE_DHA_CHALLAN_DATA, data: null })
  })(Sidebar)
);
